<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 完成评级列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<!-- <el-select v-model="bill" placeholder="请选择评级订单" clearable>
					<el-option v-for="item in billList" :key="item.Id" :label="item.Name" :value="item.Id">
					</el-option>
				</el-select> -->
				<el-input placeholder="商品标签码" class="handle-input mr10" v-model="QRFont" clearable></el-input>
				<!-- <el-input placeholder="商品名称" class="handle-input mr10" v-model="goodsName" clearable></el-input> -->
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<!-- <el-button type="primary" icon="el-icon-circle-plus-outline" @click="createGoods">创建商品</el-button> -->
			</div>
			<el-table :data="goodsList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				style="width: 100%">
				<el-table-column prop="QRFont" label="商品标签码" align="center" min-width="300"></el-table-column>
				<!-- <el-table-column prop="Code" label="商品编码" align="center" min-width="300"></el-table-column> -->
				<el-table-column prop="Name" label="商品名称" align="center" min-width="250"></el-table-column>
				<el-table-column prop="CategoryName" label="商品分类" align="center" min-width="200"></el-table-column>
				<el-table-column prop="SerieName" label="商品系列" align="center" min-width="120"></el-table-column>
				<el-table-column prop="scoreNum" label="评级人数" align="center" min-width="250"></el-table-column>
				<el-table-column prop="LastScore" label="系统评分" align="center" min-width="150"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="pageIndex"
					:page-size="pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
			</div>

			<!-- 查看弹出框 -->
			<el-dialog :title="title" v-model="showphoto" width="30%">

				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item label="商品标签码" prop="QRFont">
						<el-input v-model="ruleForm.QRFont" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="商品名称" prop="Name">
						<el-input v-model="ruleForm.Name" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="商品分类" prop="CategoryName">
						<el-input v-model="ruleForm.CategoryName" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="商品系列" prop="SerieName">
						<el-input v-model="ruleForm.SerieName" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="Surface" prop="Surface">
						<el-input v-model="ruleForm.Surface" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="Edges" prop="Edges">
						<el-input v-model="ruleForm.Edges" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="Corners" prop="Corners">
						<el-input v-model="ruleForm.Corners" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="Centering" prop="Centering">
						<el-input v-model="ruleForm.Centering" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="总分" prop="LastScore">
						<el-input v-model="ruleForm.LastScore" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="PE/CE" prop="PE">
						<el-input v-model="ruleForm.PE" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="二维码" prop="QRCode" v-if="ruleForm.QRCode == ''?false:true">
						<el-image style="width: 200px; height: 200px;border: 1px solid #e4e7ed;" :src="ruleForm.QRCode"
							:fit="fit"></el-image>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="showphoto = false">取 消</el-button>
					</span>
				</template>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import qs from 'qs';
	export default {
		data() {
			return {
				PECE: '',
				checkList: [{
						value: 0,
						label: '无'
					},
					{
						value: 1,
						label: 'PE'
					}, {
						value: 2,
						label: 'CE'
					}, {
						value: 3,
						label: 'PE,CE'
					},
				],
				scoreId: '',
				lastScoreMsg: '', //最终分数信息
				changdu: '',
				chooseScore: false,
				showphoto: false,
				goodsName: '',
				code: '', //商品编号
				pingjiList: [],
				title: '',
				goodsList: [],
				ScoreList: [],
				billList: [],
				ruleForm: [],
				token: localStorage.getItem('access_token'),
				roleid: localStorage.getItem('RoleId'),
				Id: localStorage.getItem('Id'),
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				editVisible: false,
				rules2: {
					Centering: [{
						required: true,
						message: '正中分数不可以为空',
						trigger: 'blur'
					}],
					Corners: [{
						required: true,
						message: '四角分数不可以为空',
						trigger: 'blur'
					}],
					Edges: [{
						required: true,
						message: '四边分数不可以为空',
						trigger: 'blur'
					}],
					Surface: [{
						required: true,
						message: '表面分数不可以为空',
						trigger: 'blur'
					}],
					PE: [{
						required: true,
						message: '请选择(无,PE,CE)',
						trigger: 'change'
					}],
				},
				rules: {
					BillId: [{
						required: true,
						message: '请输入订单',
						trigger: 'change'
					}],
					Name: [{
						required: true,
						message: '请输入订单名称',
						trigger: 'blur'
					}],
					SerieId: [{
						required: true,
						message: '请选择系列名称',
						trigger: 'change'
					}],
					CategoryId: [{
						required: true,
						message: '请选择分类名称',
						trigger: 'change'
					}],
					Phone: [{
						required: true,
						message: '请输入收件人手机号',
						trigger: 'blur'
					}, {
						pattern: /^1[0123456789]\d{9}$/,
						message: '目前只支持中国大陆的手机号码',
						trigger: "blur"
					}],
					SpeedNum: [{
						required: true,
						message: '请选择是否快评',
						trigger: 'blur'
					}],
					ExpressCompany: [{
						required: true,
						message: '请输入快递公司',
						trigger: 'blur'
					}],
					TrackingNum: [{
						required: true,
						message: '请输入快递单号',
						trigger: 'blur'
					}],
				},
				isdisabled: false,

				kuaipingList: [{
						Id: 1,
						Name: '普通快评'
					},
					{
						Id: 2,
						Name: '加急快评'
					}
				],
				startTime: '', //开始时间
				endTime: '', //结束时间
				bill: '',
				billId: '',
				upResName: '',
				upResName2: '',
				treeList: [],
				treeList2: [],
				defaultProps: {
					children: 'children',
					label: 'Name',
				},
				defaultProps2: {
					children: 'children',
					label: 'Name',
				},
				fillist: [],
				isphoto: false,
				photoList: [],
				isScore: '',
				zongping: '',
				QRFont: ''
			}
		},
		created() {
			this.getGoodsList()
			this.getSerie()
			this.getclass()
		},
		methods: {
			changeUser(val) {
				this.lastScoreMsg.PE = val
			},
			//图片上传
			beforeAvatarUpload(file) {
				let dian = file.name.lastIndexOf('.')
				let type = file.name.substr(dian + 1)
				const isLt2M = file.size / 1024 / 1024 < 1
				console.log(isLt2M)
				if (this.photoList.length < 2) {
					if (!isLt2M) {
						this.$message.error('上传文件大小不能超过2M!')
					} else if (type != 'xls' && type != 'pdf' && type != 'jpg' && type != 'png' && type != 'xlsx' &&
						type != 'bmp' && type != 'jpeg' &&
						type != 'XLS' && type != 'PDF' && type != 'JPG' && type != 'PNG' && type != 'XLSX' && type !=
						'BMP' && type != 'JPEG') {
						this.$message.error('上传图片必须是 xls / pdf / jpg / png / xlsx / bmp / jpeg 格式!');
					} else {
						let formdata = ''
						formdata = new FormData()
						formdata.append('file', file)
						axios({
							method: 'post',
							url: this.$store.state.pcurl + "CollectiblesPhotoUpload",
							data: formdata
						}).then((res) => {
							if (res.data.Message == '请求成功') {
								res.data.Data[0].Url = res.data.Data[0].url
								this.photoList.push(res.data.Data[0])
							}
						})
					}
				} else {
					this.$message.error('只可以传两张图片！')
				}
			},
			handleExceed(fileList) {
				console.log(fileList)
				this.$message.error("当前选择图片为 " + fileList.length + " 张,只可以传 2 张图片!")
			},
			//确认上传
			uploadPhoto() {
				this.ruleForm.CreateUserId = this.Id
				this.ruleForm.State = 1
				this.ruleForm.Url = []
				this.photoList.forEach((x) => {
					this.ruleForm.Url = x.url
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "AddCollectiblesPhoto",
						headers: {
							"Authorization": "bearer " + this.token
						},
						data: this.ruleForm
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.$message({
								message: '上传成功!',
								type: 'success'
							});
							this.isphoto = false
							this.getGoodsList()
						}
					})
				})
			},
			//上传照片
			photoBtn(row) {
				this.title = '上传照片'
				this.isphoto = true
				this.photoList = []
				this.ruleForm = row
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCollectiblesPhotos?biilId=" + row.BillId,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						console.log(res.data.Data)
						res.data.Data.forEach((x) => {
							if (x.Name == row.Name) {
								this.photoList.push(x)
							}
						})
					}
				})
			},
			deleGoods(row) {
				console.log(row.Id)
				this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "DeleteCollectiblesPool?Id=" + row.Id,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getGoodsList()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},

			handleNodeClick(data) {
				this.upResName = data.Name
				this.ruleForm.SerieId = data.Id
			},
			handleNodeClick2(data) {
				this.upResName2 = data.Name
				this.ruleForm.CategoryId = data.Id
			},
			buildTree(arr, ParentId) {
				let tree = [];
				arr.map((item) => {
					if (item.ParentId === ParentId) {
						item.children = this.buildTree(arr, item.Id);
						tree.push(item);
					}
				});
				return tree;
			},
			//获取全部系列
			getSerie() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetSeries?&pageSize=99999" + '&name=' + '' + '&pageIndex=0',
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.treeList = this.buildTree(res.data.Data, null)
					} else {
						this.$message.error('分类列表获取失败')
					}
				})
			},
			//获取全部分类
			getclass() {
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCategories?&pageSize=99999" + '&name=' + '' +
						'&pageIndex=0',
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.treeList2 = this.buildTree(res.data.Data, null)
					} else {
						this.$message.error('分类列表获取失败')
					}
				})
			},
			handleClear(obj) {
				// 将选择器的值置空
				if (obj == 'class') {
					this.upResName2 = ''
					this.ruleForm.CategoryId = ''
				} else {
					this.upResName = ''
					this.ruleForm.SerieId = ''
				}

			},

			handleCurrentChange(val) {
				console.log(val)
				if (val) {
					this.lastScoreMsg = val
					this.scoreId = val.Id
				}
			},

			setCurrent(row) {
				this.$refs.multipleTable.setCurrentRow(row);
			},
			//修改分数系统自己算总分
			change(val) {
				console.log(val)
				if (val == 'Surface') {
					console.log(this.lastScoreMsg.Surface)
				}
				axios({
					method: 'post',
					url: this.$store.state.pcurl + 'SysScore?Surface=' + this.lastScoreMsg.Surface + '&Corners=' +
						this.lastScoreMsg.Corners + '&Edges=' + this.lastScoreMsg.Edges,
				}).then((res) => {
					this.lastScoreMsg.SystemScore = res.data
				})
			},
			//总评修改分数
			changeScore(row) {
				this.ScoreList = []
				this.lastScoreMsg = ''
				this.title = '总评打分'
				console.log(row)
				axios({
					method: 'get',
					url: this.$store.state.pcurl + 'GetGradeScore?Id=' +
						row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					if (res.data.Data == '') {
						this.chooseScore = true
						this.lastScoreMsg = row
						this.lastScoreMsg.CollectiblesId = row.Id
						this.lastScoreMsg.PE = this.checkList[0].value
					} else {
						res.data.Data.forEach((x) => {
							if (x.State == 1) {
								this.scoreId = x.Id
								let dian = res.data.Data.indexOf(x)
								this.setCurrent(res.data.Data[dian])
							}
							if (x.State == 2) {
								this.lastScoreMsg = x
							}
						})

						res.data.Data.forEach((x) => {
							if (x.State != 2) {
								this.ScoreList.push(x)
							}
						})
						this.chooseScore = true
						this.ScoreList.forEach((x) => {
							if (x.GradeUserId) {
								axios({
									method: 'get',
									url: this.$store.state.pcurl + 'GetUserModel?userId=' +
										x.GradeUserId,
									headers: {
										"Authorization": "bearer " + this.token
									},
								}).then((res) => {
									x.GradeName = res.data.Data.Name
								})
							}

							switch (x.PE) {
								case 0:
									x.PEName = '无';
									break;
								case 1:
									x.PEName = 'PE';
									break;
								case 2:
									x.PEName = 'CE';
									break;
								case 3:
									x.PEName = 'PE,CE';
									break;
							}
						})
					}
				})
			},
			//创建商品
			createGoods() {
				this.isdisabled = false
				this.title = '创建商品'
				this.editVisible = true
				this.ruleForm = []
			},
			//获取商品列表
			getGoodsList() {
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCollectiblesPrint?pageIndex=" + pageIndex + '&pageSize=' +
						this.pageSize + '&QRFont=' + this.QRFont,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					this.pageTotal = res.data.Count
					this.goodsList = res.data.Data
					this.goodsList.forEach((x) => {
						if (x.CategoryId) {
							axios({
								method: 'get',
								url: this.$store.state.pcurl + 'GetCategoryModel?categoryId=' +
									x.CategoryId,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								x.CategoryName = res.data.Data.Name
							})
						}
						if (x.SerieId) {
							axios({
								method: 'get',
								url: this.$store.state.pcurl + 'GetSeriesModel?seriesId=' +
									x.SerieId,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								x.SerieName = res.data.Data.Name
							})
						}

						axios({
							method: 'get',
							url: this.$store.state.pcurl + 'GetGradeScore?Id=' +
								x.Id,
							headers: {
								"Authorization": "bearer " + this.token
							},
						}).then((res) => {
							x.changdu = res.data.Data.length
							if (res.data.Data) {
								res.data.Data.forEach((y) => {
									if (y.State == 2 && y.GradeUserId != this.Id) {
										x.zongping = true
									} else {
										x.zongping = false
									}
								})
							}
						})
						switch (x.State) {
							case 1:
								x.scoreNum = '无人打分';
								break;
							case 2:
								x.scoreNum = '一人已打分';
								break;
							case 3:
								x.scoreNum = '二人已打分';
								break;
							case 4:
								x.scoreNum = '三人已打分';
								break;
							case 5:
								x.scoreNum = '总评已打分';
								break;
							case 6:
								x.scoreNum = '总评已打分';
								break;
						}
						if (x.Star == 1) {
							x.isStar = '是'
						} else {
							x.isStar = '否'
						}
						axios({
							method: 'get',
							url: this.$store.state.pcurl + 'GetCollectiblesPoolModel?Id=' +
								x.Id,
							headers: {
								"Authorization": "bearer " + this.token
							},
						}).then((res) => {
							x.QRFont = res.data.Data.QRFont
						})
					})
				})
			},
			//监听时间变化
			changeTime() {
				let start = JSON.stringify(this.value2[0])
				let end = JSON.stringify(this.value2[1])
				this.startTime = JSON.parse(start).replace(/T|\.\d{3}Z/g, " ")
				this.endTime = JSON.parse(end).replace(/T|\.\d{3}Z/g, " ")
				console.log(this.startTime, this.endTime)
			},
			//搜索
			handleSearch() {
				this.pageIndex = 1
				this.billId = this.bill
				this.getGoodsList()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getGoodsList()
			},
			// 编辑
			handleEdit(index, row) {
				console.log(row)
				this.ruleForm = []
				this.photoList = []
				this.title = '编辑打分'
				this.isdisabled = false
				this.showphoto = true
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCollectiblesPhotos?biilId=" + row.BillId +
						'&CollectiblesId=' + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						res.data.Data.forEach((x) => {
							this.photoList.push(x)
						})
					}
				})


				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetGradeScore?Id=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					res.data.Data.forEach((x) => {
						if (x.GradeUserId == this.Id) {
							this.ruleForm = x
						}
					})
					this.ruleForm.Name = row.Name
					console.log(this.ruleForm)
				})

			},
			//查看
			handleClick(row) {
				this.title = '商品详情'
				this.ruleForm = row
				this.isdisabled = true
				this.showphoto = true
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '打分') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							this.ruleForm.CollectiblesId = this.ruleForm.Id
							this.ruleForm.GradeUserId = this.Id
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "AddGradeScore",
								data: qs.stringify(this.ruleForm),
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.showphoto = false
									this.$message({
										message: '增加分数成功',
										type: 'success'
									})
									console.log(this.ruleForm)
									this.getGoodsList()
								} else {
									this.$message.error('增加失败')
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else if (this.title == '编辑打分') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateGradeScore",
								data: this.ruleForm,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.showphoto = false
									this.$message({
										message: '修改分数成功',
										type: 'success'
									})
									this.getGoodsList()
								} else {
									this.$message.error('修改失败')
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else if (this.title == '总评打分') {
					console.log(this.lastScoreMsg)
					this.lastScoreMsg.GradeUserId = this.Id
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "LastScore?scoreId=" + this.scoreId,
						data: this.lastScoreMsg,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.chooseScore = false
							this.$message({
								message: '总评打分成功',
								type: 'success'
							})
							this.getGoodsList()
						} else {
							this.$message.error('打分失败')
						}
					})
				} else {
					this.editVisible = false
				}
			}
		}
	};
</script>

<style scoped lang="less">
	:deep(.el-form-item .el-form-item__label) {
		width: 100px !important;
	}

	:deep(.current-row) {
		color: red !important;
	}

	.el-select {
		width: 300px;
		margin-right: 10px;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	:deep(.el-upload) {
		width: 56px !important;
		height: 32px;
		border: none;
		line-height: 0;
	}

	:deep(.el-upload-list) {
		height: 0px !important;
	}

	:deep(.el-form-item__label) {
		width: 120px !important;
	}

	:deep(.el-form-item__content) {
		margin-left: 120px !important;
	}

	.listPhoto {
		width: 514px;
		border: 1px solid #DCDFE6;
		height: 300px;
		border-radius: 10px;
		margin-bottom: 20px;
		overflow: hidden;
	}

	:deep(.el-dialog) {
		max-height: 700px;
	}
</style>
